import { COMPARISON_TABLE_DISPLAY_CONTENT } from '../newComparisonTableConfig';
import { DetailViewValue } from '../types';
import { ensureValidDecimalsPrecision } from '../../../../../../helpers/DecimalsPrecisionHelpers';
import useExperimentDetailsTemplateState from '@experiment-details/hooks/useExperimentDetailsTemplateState';
import { ExperimentTemplate } from '@experiment-details/types';
import { Paths } from '@shared/types';
import { DEFAULT_DECIMAL_PRECISION } from '@experiment-management-shared/constants/experimentGridConstants';

type UseComparisonDecimalPrecisionOptions = {
  detailView: DetailViewValue;
};

const useComparisonDecimalPrecision = ({
  detailView
}: UseComparisonDecimalPrecisionOptions) => {
  const { viewName } = COMPARISON_TABLE_DISPLAY_CONTENT[detailView];

  const [
    decimalsPrecision,
    setDecimalsPrecision
  ] = useExperimentDetailsTemplateState(
    `${viewName}.decimalsPrecision` as Paths<ExperimentTemplate>,
    DEFAULT_DECIMAL_PRECISION
  );

  const onChangeDecimalsPrecision = (value: number) => {
    setDecimalsPrecision(value);
  };

  return {
    decimalsPrecision: ensureValidDecimalsPrecision(decimalsPrecision),
    onChangeDecimalsPrecision
  };
};

export default useComparisonDecimalPrecision;
